import { animate } from 'motion'

export const useHeights = () => {
    const processed = ref(false)
    const panels = ref([])
    const openedPanels = ref([])

    const calculateHeights = () => {
        if (!processed.value) {
            for (let i = 0, il = panels.value.length; i < il; ++i) {
                const el = panels.value[i]
                el.dataset.realHeight = el.getBoundingClientRect().height
            }
            processed.value = true
        }
    }

    const removePanel = (arr, id) => {
        arr.splice(arr.indexOf(id), 1)
    }

    const openPanel = (el, done) => {
        if (el && processed.value) {
            const anim = animate(el, {
                height: `${el.dataset.realHeight}px`,
            }, {
                duration: 1,
                easing: [0.63, 0.58, 0.31, 0.93],
                allowWebkitAcceleration: true,
            })
            anim.finished.then(() => {
                done()
            })
        }
        else {
            done()
        }
    }

    const closePanel = (el, done) => {
        if (el && processed.value) {
            const anim = animate(el, {
                height: `${el.dataset.minHeight ?? 0}px`,
            }, {
                duration: 1,
                easing: [0.63, 0.58, 0.31, 0.93],
                allowWebkitAcceleration: true,
            })
            anim.finished.then(() => {
                done()
            })
        }
        else {
            done()
        }
    }

    return {
        panels, openedPanels, processed, calculateHeights, openPanel, closePanel, removePanel,
    }
}
